import { MenuList } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { HorizontalDivider } from "../../../common/components";
import { MenuItemRelog, MenuItemSelectable, MenuListTitle } from "..";
import { checkValidity } from "../..";
import style from "./MentionMenu.module.css";
import { environmentSwitch, translate } from "../../../common/providers";

const ADMIN_COMPANY = "VEOLIA EAU";

const CompanyMenu = React.forwardRef(({ companies, company, homeMenus, onHotRelog, onIsSelected, onSelect }, ref) => {
	const [menus, setMenus] = useState([]);
	const [homeMenusExists, setHomeMenuExists] = useState(false);
	const [isInAdmin, setIsInAdmin] = useState(false);
	const [hasCompaniesList, setHasCompaniesList] = useState(false);
	useEffect(() => {
		if (Array.isArray(homeMenus) && homeMenus.length > 0) {
			const tempMenus = homeMenus.filter((m) => checkValidity(m));
			setMenus(tempMenus);
			setHomeMenuExists(tempMenus.length > 0);
		} else {
			setHomeMenuExists(false);
		}
	}, [homeMenus]);
	const mainHasCompanies = useCallback(() => {
		if (Array.isArray(companies) && companies.filter((c) => c.id !== company.id).length > 0) {
			setHasCompaniesList(true);
		} else {
			setHasCompaniesList(false);
		}
	}, [companies, company]);
	const veoliaIsInAdmin = useCallback(() => {
		if (companies.find((cmp) => cmp.id === company.id && cmp.companyName === ADMIN_COMPANY)) {
			setIsInAdmin(true);
		} else {
			setIsInAdmin(false);
		}
	}, [companies, company]);
	useEffect(() => {
		environmentSwitch({
			main: mainHasCompanies(),
			veolia: veoliaIsInAdmin(),
		});
	}, [mainHasCompanies, veoliaIsInAdmin]);
	const getFilteredCompanies = () =>
		environmentSwitch({
			main: companies,
			smac: companies,
			veolia: companies.filter(
				(cmp) =>
					(isInAdmin && cmp.companyName !== ADMIN_COMPANY) ||
					(!isInAdmin && cmp.companyName === ADMIN_COMPANY)
			),
		});
	const renderCompanyList = () =>
		getFilteredCompanies().map((relog) => (
			<MenuItemRelog key={relog.id} company={company} menuItem={relog} onHotRelog={onHotRelog} />
		));
	return (
		<>
			{homeMenusExists && (
				<MenuList ref={ref}>
					{menus.map((menuItem) => (
						<MenuItemSelectable
							key={menuItem.name}
							menuItem={menuItem}
							onIsSelected={onIsSelected}
							onSelect={onSelect}
						/>
					))}
				</MenuList>
			)}
			{environmentSwitch({
				main: hasCompaniesList && (
					<>
						{homeMenusExists && <HorizontalDivider />}
						<MenuListTitle
							menuItem={environmentSwitch({
								main: translate("navigation:home.change-company"),
								veolia: translate("navigation:home.administration"),
							})}
						/>
						<MenuList data-testid="companyMenu.companyList">{renderCompanyList()}</MenuList>
					</>
				),
				veolia: (
					<div className={style.menu_dropdown__items_container}>
						{homeMenusExists && <HorizontalDivider />}
						<MenuList data-testid="companyMenu.companyList">{renderCompanyList()}</MenuList>
					</div>
				),
			})}
		</>
	);
});
export default CompanyMenu;
